// Access token storage in memory only (no localStorage/sessionStorage)
//
// SECURITY: Access tokens are NEVER persisted to storage
// - Page refresh/reload: token is cleared (user will silent refresh)
// - Browser close: token is cleared (cookie remains for next session)
// - XSS protection: token cannot be stolen from localStorage
//
// This is the modern SPA security standard:
// 1. Access Token → Memory only (short-lived, 15 minutes)
// 2. Refresh Token → HttpOnly Cookie (long-lived, 30 days)
// 3. Silent Refresh → On app initialization

let accessToken: string | null = null;
let tokenExpiresAt: Date | null = null;

export const getAccessToken = (): string | null => {
  // Check if token has expired
  if (accessToken && tokenExpiresAt) {
    const now = new Date();
    if (now >= tokenExpiresAt) {
      // Token expired, clear it
      accessToken = null;
      tokenExpiresAt = null;
    }
  }
  return accessToken;
};

export const setAccessToken = (token: string | null, expiresAt?: Date): void => {
  accessToken = token;
  tokenExpiresAt = expiresAt || null;
};

export const isTokenExpired = (): boolean => {
  if (!tokenExpiresAt) return true;
  // Consider expired 30 seconds before actual expiry for safety
  return new Date() >= new Date(tokenExpiresAt.getTime() - 30000);
};

export const clearAccessToken = (): void => {
  accessToken = null;
  tokenExpiresAt = null;
};
